import * as moment from 'moment';

export const config = {
  anzahlungMehrtagesReise: 50,
  anzahlungTagesReise: 100,
  anzahlungZeitraum: moment.duration(8, 'weeks'),
  restzahlungZeitraum: moment.duration(2, 'weeks'),
  bearbeitungspauschale: 10,
  geburtsdatumMin: moment().subtract(100, 'years').toDate(),
  geburtsdatumInit: moment().subtract(30, 'years').toDate(),
  geburtsdatumMax: moment().toDate(),
  jugendMaxAlter: moment.duration(18, 'years'),
  kindMaxAlter: moment.duration(13, 'years')
};
